import { render, staticRenderFns } from "./Job.vue?vue&type=template&id=64b77329&scoped=true&"
import script from "./Job.vue?vue&type=script&lang=js&"
export * from "./Job.vue?vue&type=script&lang=js&"
import style0 from "./Job.vue?vue&type=style&index=0&id=64b77329&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b77329",
  null
  
)

export default component.exports